export const AP_HOMEPAGE_LOADER = {
  desktop: `
    <div class="cui cui-grid cui-container">
      <div style="display: flex; flex-direction: column">
        <section style="display: grid; grid-template-columns: 1.4fr 1fr; gap: 24px; align-items: center; height: 720px;">
          <div>
            <div class="cui-skeleton-heading -size--large -resolution--desktop" style="width: 100%; margin-bottom: 16px;">
              <div class="cui-skeleton-heading__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 264px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
              </div>
            </div>
            <div class="cui-skeleton-button -size--small">
              <div class="cui-skeleton-button__content" style="width: 174px;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
        </section>
        <section style="display: grid; grid-template-columns: 1fr 1fr; align-items: center;">
          <div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 220px; height: 36px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 76%; height: 14px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 76%; height: 14px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 76%; height: 14px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 76%; height: 14px;"></div>
            </div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="padding: 80px 0 80px 0;">
            <div class="cui-skeleton__item" style="width: 100%; height: 395px;"></div>
          </div>
        </section>
        <section style="padding: 80px 0 80px 0;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
          </div>
          <div style="display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; padding-top: 64px;">
            <article>
              <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 10px;">
                <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
              </div>
            </article>
            <article>
              <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 10px;">
                <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
              </div>
            </article>
            <article>
              <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 10px;">
                <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
              </div>
            </article>
          </div>
        </section>
        <section style="padding: 80px 0 80px 0;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 64px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
          </div>
          <div style="display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px;">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
            </div>
          </div>
        </section>
        <section style="display: grid; grid-template-columns: 1.4fr 1fr; gap: 24px; align-items: center; height: 720px;">
          <div>
            <div class="cui-skeleton-heading -size--large -resolution--desktop" style="width: 100%; margin-bottom: 16px;">
              <div class="cui-skeleton-heading__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 264px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px;"></div>
              </div>
            </div>
            <div class="cui-skeleton-button -size--small">
              <div class="cui-skeleton-button__content" style="width: 174px;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
        </section>
        <section style="padding: 80px 0 80px 0;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 64px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
          </div>
          <div style="display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px;">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 192px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 192px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 192px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 192px;"></div>
            </div>
          </div>
        </section>
        <section style="padding: 80px 0 80px 0;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
          </div>
          <div style="display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; margin-top: 64px;">
            <article>
              <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 10px;">
                <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
              </div>
            </article>
            <article>
              <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 10px;">
                <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
              </div>
            </article>
            <article>
              <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 10px;">
                <div class="cui-skeleton__item" style="width: 100%; height: 485px;"></div>
              </div>
            </article>
          </div>
        </section>
        <section style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; align-items: center; margin: 80px 0;">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 395px;"></div>
          </div>
          <div style=" padding: 0 0 0 96px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px; ">
              <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-button -size--small">
              <div class="cui-skeleton-button__content" style="width: 120px;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
        </section>
        <section style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; align-items: center; margin: 80px 0;">
          <div style=" padding: 0 96px 0 0;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px; ">
              <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="cui-skeleton-button -size--small">
              <div class="cui-skeleton-button__content" style="width: 120px;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 395px;"></div>
          </div>
        </section>
      </div>
    </div>`,
  mobile: `
    <div class="cui cui-grid cui-container">
      <div style="display: flex; flex-direction: column">
        <section>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 215px;"></div>
          </div>
          <div style="margin: 32px 0;">
            <div class="cui-skeleton-heading -size--large -resolution--mobile" style="width: 100%;">
              <div class="cui-skeleton-heading__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 264px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 16px; "></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 12px; "></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 12px; "></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 12px; "></div>
              </div>
            </div>
            <div class="cui-skeleton-button -size--small" style="margin-top: 16px;">
              <div class="cui-skeleton-button__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
        </section>
        <section style="margin-bottom: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 205px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px; margin-bottom: 16px; "></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
        </section>
        <section style="margin-top: 32px; margin-bottom: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 48px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
          </div>
          <article style="margin-bottom: 48px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 4px;">
              <div class="cui-skeleton__item" style="width: 63px; height: 18px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px; margin-bottom: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 75px; height: 20px;"></div>
            </div>
          </article>
          <article style="margin-bottom: 48px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 4px;">
              <div class="cui-skeleton__item" style="width: 63px; height: 18px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px; margin-bottom: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 75px; height: 20px;"></div>
            </div>
          </article>
          <article>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 4px;">
              <div class="cui-skeleton__item" style="width: 63px; height: 18px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px; margin-bottom: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 75px; height: 20px;"></div>
            </div>
          </article>
        </section>
        <section>
          <div class="cui-skeleton-rectangle -is--block" style="margin: 32px 0 48px 0;">
            <div class="cui-skeleton__item" style="width: 264px; height: 72px;"></div>
          </div>

          <article style="margin: 48px 0 16px 0; padding: 16px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px; display: flex; justify-content: center;">
              <div class="cui-skeleton__item" style="width: 232px; height: 232px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" >
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
          </article>
          <article style="margin: 0px 0 16px 0; padding: 16px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px; display: flex; justify-content: center;">
              <div class="cui-skeleton__item" style="width: 232px; height: 232px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" >
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
          </article>
              <article style="margin: 0px 0 16px 0; padding: 16px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px; display: flex; justify-content: center;">
              <div class="cui-skeleton__item" style="width: 232px; height: 232px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" >
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
          </article>
        </section>
        <section style="margin-top: 32px; margin-bottom: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 215px;"></div>
          </div>
          <div style="margin: 32px 0 0 0;">
            <div class="cui-skeleton-heading -size--large -resolution--mobile" style="width: 100%;">
              <div class="cui-skeleton-heading__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 264px;"></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 16px; "></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 12px; "></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 12px; "></div>
                <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px; margin-top: 12px; "></div>
              </div>
            </div>
            <div class="cui-skeleton-button -size--small" style="margin-top: 16px;">
              <div class="cui-skeleton-button__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton-button__button"></div>
              </div>
            </div>
          </div>
        </section>
        <section style="margin-top: 32px; margin-bottom: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 48px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 72px;"></div>
          </div>
          <div style="display: grid; grid-template-columns: 1fr; gap: 16px;">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 111px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 111px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 111px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 111px;"></div>
            </div>
          </div>
        </section>
        <section style="margin-top: 32px; margin-bottom: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 48px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 40px;"></div>
          </div>
          <article style="margin-bottom: 48px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 4px;">
              <div class="cui-skeleton__item" style="width: 63px; height: 18px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px; margin-bottom: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 75px; height: 20px;"></div>
            </div>
          </article>
          <article style="margin-bottom: 48px;">
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 4px;">
              <div class="cui-skeleton__item" style="width: 63px; height: 18px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px; margin-bottom: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 75px; height: 20px;"></div>
            </div>
          </article>
          <article>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 4px;">
              <div class="cui-skeleton__item" style="width: 63px; height: 18px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 8px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 54px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 12px; margin-bottom: 16px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 75px; height: 20px;"></div>
            </div>
          </article>
        </section>
        <section style="margin-bottom: 32px; margin-top: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 205px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 36px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>

          <div class="cui-skeleton-button -size--small" style="margin-top: 16px;">
            <div class="cui-skeleton-button__content" style="width: 100%; height: 40px;">
              <div class="cui-skeleton__item cui-skeleton-button__button"></div>
            </div>
          </div>
        </section>
        <section style="margin-bottom: 32px; margin-top: 32px;">
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 205px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 16px;">
            <div class="cui-skeleton__item" style="width: 264px; height: 36px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block" style="margin-bottom: 12px;">
            <div class="cui-skeleton__item" style="width: 100%; height: 16px;"></div>
          </div>

          <div class="cui-skeleton-button -size--small" style="margin-top: 16px;">
            <div class="cui-skeleton-button__content" style="width: 100%; height: 40px;">
              <div class="cui-skeleton__item cui-skeleton-button__button"></div>
            </div>
          </div>
        </section>
      </div>
    </div>`
};
